module.exports = __webpack_public_path__ + "img/107.376e3c4c.png";